import React from 'react';
import CreateCatAut from '../components/FirstSection/createCatAut';

const SelectCatAut = () => {
  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <CreateCatAut />
    </div>
  )
}

export default SelectCatAut
